import {default as Component} from './SignUpForm'
import {changeUsername, changePassword, changeEmail} from '../../redux/actions'
import {signUp} from '../../redux/endpointActions'
import {connect} from 'react-redux'

const servicePath = process.env.REACT_APP_SERVICE_ENDPOINT + 'user'

const SignUpForm = connect(
	(state) => ({
		username: state.userInfo.username,
		email: state.userInfo.email,
		password: state.userInfo.password,
		disabled: state.signUpForm.disabled,
		err: state.signUpForm.err,
	}),
	(dispatch) => ({
		submit: (username, email, password) => {
			signUp(servicePath)(username, email, password)(dispatch)
		},
		usernameChanged: (username) => {
			dispatch(changeUsername(username))
		},
		emailChanged: (email) => {
			dispatch(changeEmail(email))
		},
		passwordChanged: (password) => {
			dispatch(changePassword(password))
		}
	})
)(Component)

SignUpForm.defaultProps = {
	username: null,
	password: null,
	email: null,
	usernameChanged: null,
	passwordChanged: null,
	emailChanged: null,
	disabled: null,
	submit: null
}

export default SignUpForm


// WEBPACK FOOTER //
// ./src/components/SignUpForm/index.js